import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import s from './Classic.scss';
import { Player } from '../../../common/components/Player/Player';
import { VideoAspectRatio } from '../../../common/components/VideoAspectRatio/VideoAspectRatio';
import { Header } from './Header/Header';
import { Videos } from './Videos/Videos';
import { useSelectedVideo } from '../../../hooks';
import { Overlay } from './Overlay/Overlay';
import { Search } from './Search/Search';
import { Categories } from './Categories/Categories';
import { NoResult } from './Search/NoResult/NoResult';
import { useVideosFilter } from '../../../hooks/useVideosFilter';
import { useChannelVideos } from '../../../hooks/useChannelVideos';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../stylesParams';

const useViewSettings = () => {
  const styles = useStyles();
  const showChannelCategories = styles.get(stylesParams.showChannelCategories);
  const showSearch = styles.get(stylesParams.showSearch);
  return { showChannelCategories, showSearch };
};

export const Classic: FC = () => {
  const { selectedVideo } = useSelectedVideo();
  const { isEmptyFilter } = useVideosFilter();
  const { videos, videosLoading } = useChannelVideos();
  const { showChannelCategories, showSearch } = useViewSettings();

  const showNoResult = useMemo(
    () => !isEmptyFilter && !videos.length && !videosLoading,
    [isEmptyFilter, videos, videosLoading],
  );

  return (
    <div className={classNames(s.root)}>
      <Header />
      <VideoAspectRatio>
        {selectedVideo && <Player video={selectedVideo} />}
        <Overlay />
      </VideoAspectRatio>
      <div className={s.footer}>
        {showSearch ? (
          <div className={s.search}>
            <Search />
          </div>
        ) : null}
        {showChannelCategories ? (
          <div className={s.categories}>
            <Categories />
          </div>
        ) : null}
        <div className={s.videos}>
          <Videos />
          {showNoResult && (
            <div className={s.noSearchResult}>
              <NoResult />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
